import { DictionaryPhotoshop_de_DE } from './de_DE';
import { DictionaryPhotoshop_en_US } from './en_US';
import { DictionaryPhotoshop_es_ES } from './es_ES';
import { DictionaryPhotoshop_fr_FR } from './fr_FR';
import { DictionaryPhotoshop_ja_JP } from './ja_JP';
import { DictionaryPhotoshop_ko_KR } from './ko_KR';
import { DictionaryPhotoshop_pt_BR } from './pt_BR';
import { DictionaryPhotoshop_zh_CN } from './zh_CN';
import { DictionaryPhotoshop_zh_TW } from './zh_TW';

export const PhotoshopDictionaries = {
    de_DE: DictionaryPhotoshop_de_DE,
    en_US: DictionaryPhotoshop_en_US,
    es_ES: DictionaryPhotoshop_es_ES,
    fr_FR: DictionaryPhotoshop_fr_FR,
    ja_JP: DictionaryPhotoshop_ja_JP,
    ko_KR: DictionaryPhotoshop_ko_KR,
    pt_BR: DictionaryPhotoshop_pt_BR,
    zh_CN: DictionaryPhotoshop_zh_CN,
    zh_TW: DictionaryPhotoshop_zh_TW,
};
